(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[515],{

/***/ 7783:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post/[slug]",
      function () {
        return __webpack_require__(5322);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ PostPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var _features_ui_main__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3634);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8038);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _features_ui_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6596);
/* harmony import */ var _features_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9194);
/* harmony import */ var _features_blog_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8009);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7378);
/* harmony import */ var _features_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1453);
/* harmony import */ var _features_blog_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1967);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3374);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _features_blog_queries__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6104);











var __N_SSP = true;
function PostPage(props) {
    var ref;
    const { post , url  } = props;
    const [viewed, setViewed] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    const user = (0,_features_user__WEBPACK_IMPORTED_MODULE_7__/* .useUser */ .aF)();
    const draft = (0,_features_blog_queries__WEBPACK_IMPORTED_MODULE_9__/* .useDraft */ .LH)({
        id: post.id
    });
    const viewPost = (0,_features_blog_queries__WEBPACK_IMPORTED_MODULE_9__/* .useViewPost */ .El)();
    const { i18n  } = (0,_features_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useI18n */ .QT)();
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        if (!viewed) {
            viewPost.mutate({
                id: post.id
            });
            setViewed(true);
        }
    }, [
        viewPost,
        viewed,
        post.id
    ]);
    const darftUrl = (0,_features_blog_helpers__WEBPACK_IMPORTED_MODULE_8__/* .getDraftUrl */ .T3)({
        id: post.id,
        edit: true
    });
    const publishedAt = new Date(post.publishedAt);
    const description = (0,_features_blog_helpers__WEBPACK_IMPORTED_MODULE_8__/* .getSeoDescription */ .Jh)(post.content);
    const image = (0,_features_blog_helpers__WEBPACK_IMPORTED_MODULE_8__/* .getSeoImage */ .UX)(post.content);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: post.title
                    }),
                    post.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: post.title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: url
                    }),
                    image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: image
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:author",
                        content: "lsndr"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:published_time",
                        content: post.publishedAt
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:modified_time”",
                        content: post.updatedAt
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: url
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_ui_main__WEBPACK_IMPORTED_MODULE_1__/* .Main */ .o, {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().page),
                rightSidebar: user.data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_ui_form__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                    type: "link",
                    href: darftUrl,
                    block: true,
                    children: !((ref = draft.data) === null || ref === void 0 ? void 0 : ref.published) ? i18n("continueDraftEditing") : i18n("editDraft")
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_blog_components__WEBPACK_IMPORTED_MODULE_5__/* .Post */ .SO, {
                    date: publishedAt,
                    title: post.title || undefined,
                    content: post.content,
                    tags: post.tags
                })
            })
        ]
    });
}


/***/ }),

/***/ 3374:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__BP257"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [357,362,33,548,92,604,804,774,888,179], function() { return __webpack_exec__(7783); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);